export default __webpack_public_path__ + "static/1-884fcf94c8fcaa9c88e312dabf2aae8c.webp";